// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-dialog {
  min-height: 20rem;
  min-width: 25rem;
}
.settings-dialog .form {
  min-height: 100%;
  min-width: 100%;
  margin-bottom: 1rem;
  background-color: inherit;
}
.settings-dialog .drawer {
  width: 80%;
}
.settings-dialog .related {
  height: 0;
}
.settings-dialog .padding {
  padding-left: 1rem;
}
.settings-dialog .settings-padding {
  margin-right: 1rem;
}
.settings-dialog .min-max {
  width: 5rem;
}
.settings-dialog .time-horizon {
  width: -moz-fit-content;
  width: fit-content;
  padding-left: 1rem;
}
.settings-dialog .time-duration {
  width: 4rem;
  padding-left: 1rem;
}
.settings-dialog .edit-virtual-scroll {
  min-height: 15rem;
  width: 100%;
}
.settings-dialog .search-row {
  display: flex;
  align-items: center;
}
.settings-dialog .search-row .show-all {
  margin-left: auto;
}
.settings-dialog .font-size {
  width: 4rem;
}
.settings-dialog .title {
  width: 20rem;
}

.drag-cursor {
  cursor: move;
}

.drag-list {
  width: 25rem;
  max-width: 100%;
  border: solid 1px #ccc;
  min-height: 60px;
  display: block;
  background: white;
  border-radius: 4px;
  overflow: hidden;
}

.drag-box {
  padding: 0.5rem 0.5rem;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box:last-child {
  border: none;
}

.drag-list.cdk-drop-list-dragging .drag-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}`, "",{"version":3,"sources":["webpack://./src/app/widgets/dtc-widget/dtc-widget-settings/dtc-widget-settings.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,gBAAA;AACJ;AACI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AACR;AAEI;EACI,UAAA;AAAR;AAGI;EACI,SAAA;AADR;AAII;EACI,kBAAA;AAFR;AAKI;EACI,kBAAA;AAHR;AAMI;EACI,WAAA;AAJR;AAOI;EACI,uBAAA;EAAA,kBAAA;EACA,kBAAA;AALR;AAQI;EACI,WAAA;EACA,kBAAA;AANR;AASI;EACI,iBAAA;EACA,WAAA;AAPR;AAUI;EACI,aAAA;EACA,mBAAA;AARR;AAUQ;EACI,iBAAA;AARZ;AAYI;EACI,WAAA;AAVR;AAaI;EACI,YAAA;AAXR;;AAeA;EACI,YAAA;AAZJ;;AAeA;EACI,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAZJ;;AAeA;EACI,sBAAA;EACA,6BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAZJ;;AAeA;EACI,sBAAA;EACA,kBAAA;EACA,qHAAA;AAZJ;;AAiBA;EACI,UAAA;AAdJ;;AAiBA;EACI,sDAAA;AAdJ;;AAiBA;EACI,YAAA;AAdJ;;AAiBA;EACI,sDAAA;AAdJ","sourcesContent":[".settings-dialog {\n    min-height: 20rem;\n    min-width: 25rem;\n\n    .form {\n        min-height: 100%;\n        min-width: 100%;\n        margin-bottom: 1rem;\n        background-color: inherit;\n    }\n\n    .drawer {\n        width: 80%;\n    }\n\n    .related {\n        height: 0;\n    }\n\n    .padding {\n        padding-left: 1rem;\n    }\n\n    .settings-padding {\n        margin-right: 1rem;\n    }\n\n    .min-max {\n        width: 5rem;\n    }\n\n    .time-horizon {\n        width: fit-content;\n        padding-left: 1rem;\n    }\n\n    .time-duration {\n        width: 4rem;\n        padding-left: 1rem;\n    }\n\n    .edit-virtual-scroll {\n        min-height: 15rem;\n        width: 100%;\n    }\n\n    .search-row {\n        display: flex;\n        align-items: center;\n\n        .show-all {\n            margin-left: auto;\n        }\n    }\n\n    .font-size {\n        width: 4rem;\n    }\n\n    .title {\n        width: 20rem;\n    }\n}\n\n.drag-cursor {\n    cursor: move;\n}\n\n.drag-list {\n    width: 25rem;\n    max-width: 100%;\n    border: solid 1px #ccc;\n    min-height: 60px;\n    display: block;\n    background: white;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.drag-box {\n    padding: 0.5rem 0.5rem;\n    border-bottom: solid 1px #ccc;\n    color: rgba(0, 0, 0, 0.87);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    cursor: move;\n    background: white;\n    font-size: 14px;\n}\n\n.cdk-drag-preview {\n    box-sizing: border-box;\n    border-radius: 4px;\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n        0 8px 10px 1px rgba(0, 0, 0, 0.14),\n        0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.cdk-drag-placeholder {\n    opacity: 0;\n}\n\n.cdk-drag-animating {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.example-box:last-child {\n    border: none;\n}\n\n.drag-list.cdk-drop-list-dragging .drag-box:not(.cdk-drag-placeholder) {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
